import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import {
  getToday,
  investmentDetailsPath,
  investmentPath,
  prospectDetailsPath,
  prospectPath,
} from "../utils/varialbles";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },

  checked: {},
}));
function AddDiscount() {
  let history = useHistory();
  const [formObject, setFromObject] = useState({});
  const [lookupFile, setLookupFile] = useState(null);
  const [quantityDisable, setQuantityDisable] = useState(false);
  const [service, setService] = useState([]);
  const [disCount, setDisCount] = useState("");
  const classes = useStyles();
  const location = useLocation();
  const myparam = location.state;
  const fileInputRef = useRef(null);
  let form = {
    service_type: "",
    quantity: "",
    discount_amount: "",
    expiry: "",
    discount_type: "",
    proof: null,
    reason: "",
    cust: 0,
    emp: "",
    customer_type: "P",
    approval_status: null,
    discount_code: "SALE",
  };
  const columns = [
    // { "value": 'service_type', "imp": true, "label": 'Service Type', minWidth: 170, "filedType": "radio", "options": [{ "label": "Savart X Plan", "value": "SavartX" }, { "label": "Add-Ons", "value": "AddOns" }, { "label": "Late Renewal", "value": "LateRen" }] },
    {
      value: "service_type",
      imp: true,
      label: "Service Type",
      minWidth: 170,
      filedType: "radio",
      options: [
        { label: "Savart X Plan", value: "SavartX" },
        { label: "Investment Request", value: "Investment Request" },
        { label: "Investment Review", value: "Investment Review" },
        { label: "Late Renewal", value: "LateRen" },
        { label: "SavartX3", value: "SavartX3" },
        // { "label": "Upgrade", "value": "U" }
      ],
    },
    {
      value: "quantity",
      imp: true,
      label: "Quantity",
      minWidth: 150,
      filedType: "number",
      isDisable: true,
    },
    {
      value: "discount_amount",
      imp: true,
      label: "Discount Amount",
      minWidth: 150,
      filedType: "select",
    },
    {
      value: "expiry",
      imp: true,
      label: "Expiry Date",
      minWidth: 150,
      filedType: "date",
    },
    // {
    //   value: "discount_type",
    //   imp: true,
    //   label: "Discount Type",
    //   minWidth: 150,
    //   filedType: "radio",
    //   options: [
    //     { label: "Custom", value: "Custom" },
    //     { label: "Student", value: "Student" },
    //     { label: "Farmer", value: "Farmer" },
    //     { label: "Military", value: "Military" },
    //     { label: "Micro-Investor", value: "Micro-Investor" },
    //   ],
    // },
    {
      value: "proof",
      imp: true,
      label: "Discount proof",
      minWidth: 150,
      filedType: "file",
    },
    {
      value: "reason",
      imp: true,
      label: "Reason",
      minWidth: 150,
      filedType: "textarea",
      multiline: true,
      rows: 5,
    },
  ];
  const validations = {
    service_type: {
      conditions: {
        required: true,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    quantity: {
      conditions: {
        required: true,
        minValue: 1,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    reason: {
      conditions: {
        required: true,
        maxLength: 1000,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    expiry: {
      conditions: {
        // "required": true,"minDate":getToday(),"pattren":/^\d{4}-\d{2}-\d{2}$/
        required: true,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    discount_amount: {
      conditions: {
        required: true,
        minValue: -1,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    proof: {
      conditions: {
        required: true,
      },
      message: "Proof is required!",
      valid: true,
      changed: false,
    },
  };
  const [validationState, setValidationState] = useState(validations);
  const gotoProspectDetails = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };

  let date = new Date();
  // (date);
  let thisyear = date.getFullYear();
  // (thisyear);
  let thismonth = date.getMonth() + 1;
  // (thismonth);
  let thisday = date.getDate();
  // (thisday);

  let today =
    thisyear +
    "-" +
    ("0" + thismonth).slice(-2) +
    "-" +
    ("0" + thisday).slice(-2);
  // (today);

  useEffect(() => {
    var custid = "";

    if (myparam.cust__id || myparam.customer_id) {
      custid = myparam.cust__id || myparam.customer_id;

      http

        .get(`/payment_options?cust_id=${custid}`)
        .then((res) => {
          // const cust = res.data.data;
          // setProfile(res.data.data);
          setService(res.data.serv);
          //    setForm({
          //      ...form,
          //      firstname: cust.custfirstname,
          //      lastname: cust.custlastname,
          //      state: cust.custstate,
          //    });
          // (res.data.data.custstate);
        })
        .catch((err) => {});
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      setFromObject(form);
    } else {
      gotoProspectDetails();
    }
  }, []);
  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    let isSavartX = false;
    if (event.target.name === "service_type") {
      isSavartX = true;
      setQuantityDisable(true);
    }

    // else if (
    //   event.target.name == "service_type" &&
    //   event.target.value !== "SavartX"
    // ) {
    //   setQuantityDisable(false);
    // }

    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      if (isSavartX === false) {
        setFromObject({
          ...formObject,
          [event.target.name]: event.target.value,
        });
      } else {
        setFromObject({
          ...formObject,
          [event.target.name]: event.target.value,
          quantity: 1,
        });
      }
    }
    if (name === "service_type") {
      http
        .get(`/discount?service_type=${value}`)
        .then((res) => {
          setDisCount(res.data.data);
        })
        .catch((err) => {});
      //   setFieldDisable(false);
    }
  };

  const handleFileChange = (event) => {
    // ('test')
    let validStateTemp = { ...validationState };
    // (validStateTemp);
    // (validationState);
    let validation = handleValidation(
      "proof",
      event.target.files && event.target.files[0]
        ? event.target.files[0]
        : null,
      validStateTemp
    );
    setValidationState(validation.validStateTemp);
    // (event.target.files[0])
    // (event.target.files[0].name)
    setLookupFile(event.target.files[0]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };
    finalObjet["proof"] = lookupFile;
    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (
      finalObjet.service_type === "T" ||
      finalObjet.service_type === "RT" ||
      finalObjet.service_type === "ET"
    ) {
      finalObjet.service_type = "SavartX3";
    } else {
      finalObjet.service_type = "SavartX";
    }
    // (finalObjet, 'finalObjet');

    if (validCount === 0) {
      const formData = new FormData();
      let emp_no = localStorage.getItem("employee_id");
      let customer_id = myparam.cust__id || myparam.customer_id;
      formData.append("service_type", finalObjet["service_type"]);
      formData.append(
        "quantity",
        formObject["service_type"] && formObject["service_type"] === "SavartX"
          ? 0
          : formObject["quantity"]
      );
      // formData.append("quantity", formObject["quantity"]);
      formData.append("discount_amount", formObject["discount_amount"]);
      formData.append("expiry", formObject["expiry"]);
      formData.append("discount_type", formObject["discount_type"]);
      if (lookupFile) {
        formData.append("proof", lookupFile, lookupFile["name"]);
      }
      formData.append("reason", formObject["reason"]);
      formData.append("cust", customer_id);
      formData.append("emp", emp_no);
      formData.append("customer_type", formObject["customer_type"]);
      formData.append("approval_status", formObject["approval_status"]);
      formData.append("individual", true);
      formData.append(
        "discount_code",
        formObject["discount_code"] + formObject["discount_amount"]
      );
      http
        .post("/discount_request/" + customer_id + "/", formData)
        .then((response) => {
          if (response.data.data && response.data.statusCode === 0) {
            toast.success(response.data.data);
            if (myparam.cust__id) {
              history.push({
                pathname: prospectPath,
                state: { tab: "Discount Manager" },
              });
            } else if (myparam.customer_id) {
              history.push({
                pathname: investmentPath,
                state: { tab: "Discount Manager" },
              });
            }
          } else {
            toast.error("Discount Request Failed..!");
          }
        })
        .catch((error) => {
          toast.error("Discount Request Failed..!");
        });
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };

  return (
    <Grid container component="main" className={"pb30"}>
      <Grid item xs={12} sm={5} md={5}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoProspectDetails}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={12} sm={5} md={5} className="mt30">
        <Typography color="textPrimary" variant="h5">
          Discount Request
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 30 }}>
        {columns.map((question) => {
          return (
            <Grid container className={classes.paper}>
              <Grid item xs={12} sm={2} md={2} className={"formLable"}>
                <InputLabel
                  className={classes.lableColor}
                  id={question.lable}
                  style={{ paddingTop: "5px" }}
                >
                  {question.label}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
              </Grid>
              <Grid item lg={8} md={6} sm={6} xs={12}>
                {question.filedType === "text" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value] || ""}
                    name={question.value}
                    onChange={handleChange}
                    style={{ width: "300px" }}
                  />
                ) : question.filedType === "radio" &&
                  question.label !== "Service Type" ? (
                  <>
                    <RadioGroup
                      row
                      aria-label="position"
                      name={question.value}
                      defaultValue="A"
                      value={
                        formObject[question.value]
                          ? formObject[question.value]
                          : "A"
                      }
                      onChange={handleChange}
                    >
                      {question.options.map((option) => {
                        return (
                          <FormControlLabel
                            control={
                              <Radio
                                classes={{
                                  root: classes.radio,
                                  checked: classes.checked,
                                }}
                                value={option.value}
                              />
                            }
                            label={option.label}
                            labelPlacement="end"
                          />
                        );
                      })}
                    </RadioGroup>{" "}
                    {validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"] ? (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          margin: "3px 14px",
                        }}
                      >
                        {validationState[question.value]["message"]}
                      </div>
                    ) : null}
                  </>
                ) : question.filedType === "file" ? (
                  <>
                    <input
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      type="file"
                      style={{ display: "none" }}
                      multiple={false}
                      accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                    />
                    <Button
                      startIcon={<AddCircleOutlineIcon />}
                      variant="outlined"
                      className={classes.reviewButton}
                      color="primary"
                      onClick={() => fileInputRef.current.click()}
                    >
                      Choose File
                    </Button>
                    <span className="fileLable">
                      {lookupFile && lookupFile.name
                        ? lookupFile.name
                        : "No file chosen"}
                    </span>
                    {validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"] ? (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          margin: "3px 14px",
                        }}
                      >
                        {validationState[question.value]["message"]}
                      </div>
                    ) : null}
                  </>
                ) : question.filedType === "date" ? (
                  <TextField
                    id="datePickerId"
                    label="Select Date"
                    type="date"
                    // defaultValue="07:30"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    format="DD-MM-YYYY"
                    value={formObject[question.value] || ""}
                    onChange={handleChange}
                    InputProps={{ inputProps: { min: today } }}
                    name={question.value}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? { paddingBottom: 20, width: 335 }
                        : { width: 335 }
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                ) : question.filedType === "number" ? (
                  <TextField
                    size="small"
                    placeholder="Enter"
                    variant="outlined"
                    type="number"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    disabled={question.isDisable && quantityDisable}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? { paddingBottom: 20, width: 335 }
                        : { width: 335 }
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : ""
                    }
                  />
                ) : question.filedType === "radio" &&
                  question.label === "Service Type" ? (
                  <>
                    <RadioGroup
                      row
                      aria-label="position"
                      name={question.value}
                      defaultValue="A"
                      value={
                        formObject[question.value]
                          ? formObject[question.value]
                          : "A"
                      }
                      onChange={handleChange}
                    >
                      {service.map((item) => {
                        return (
                          <FormControlLabel
                            control={
                              <Radio
                                classes={{
                                  root: classes.radio,
                                  checked: classes.checked,
                                }}
                                value={item.value}
                              />
                            }
                            label={item.name}
                            labelPlacement="end"
                          />
                        );
                      })}
                    </RadioGroup>{" "}
                    {validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"] ? (
                      <div
                        style={{
                          color: "#f44336",
                          fontSize: "0.75rem",
                          margin: "3px 14px",
                        }}
                      >
                        {validationState[question.value]["message"]}
                      </div>
                    ) : null}
                  </>
                ) : question.filedType === "select" ? (
                  <>
                    {disCount === 0 ||
                    disCount.length <= 0 ||
                    disCount === "" ? (
                      <TextField
                        defaultValue="0"
                        placeholder="Enter"
                        variant="outlined"
                        value={formObject[question.value]}
                        name={question.value}
                        onChange={handleChange}
                        style={{ width: "335px" }}
                        type="text"
                      />
                    ) : (
                      <TextField
                        size="small"
                        select={true}
                        label="Select"
                        variant="outlined"
                        value={formObject[question.value]}
                        name={question.value}
                        onChange={handleChange}
                        style={
                          validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"]
                            ? { paddingBottom: 20, width: 335 }
                            : { width: 335 }
                        }
                        error={
                          validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"]
                        }
                      >
                        {disCount.length > 0 &&
                          disCount.map((item) => (
                            <MenuItem value={item.value}>{item.name}</MenuItem>
                          ))}
                      </TextField>
                    )}
                  </>
                ) : question.filedType === "textarea" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    multiline
                    rows={question.rows}
                    // style={{ width: 335 }}
                    style={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? { paddingBottom: 20, width: 335 }
                        : { width: 335 }
                    }
                    error={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                    }
                    helperText={
                      validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                        ? validationState[question.value]["message"]
                        : `${
                            formObject[question.value]
                              ? formObject[question.value].length
                              : 0
                          }/${
                            validationState[question.value] &&
                            validationState[question.value]["conditions"][
                              "maxLength"
                            ]
                          }`
                    }
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={2} md={2}></Grid>

        <Grid item xs={3} sm={2} md={2}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Request Discount
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddDiscount;
